module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="effect-name">Pulse</div>\n<div class="pulse-range-region"></div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/action/properties/PulseEffectPropertiesView.tpl
// module id = 1746
// module chunks = 0